// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getQuotesDataView } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { Typography } from "@insite/mobius/index";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import myAccountFilterSectionStyles from "@werner/App/SharedStyle/MyAccount/List/MyAccountFilterSectionStyles";
import { pluralize } from "@werner/XDL/Utilities";
import React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface RfqMyQuotesResultsCountStyles {
    wrapper?: InjectableCss;
    quotesCountText?: TypographyPresentationProps;
}

const rfqMyQuotesResultsCountStyles: RfqMyQuotesResultsCountStyles = {
    wrapper: {
        css: css`
            display: flex;
            margin-bottom: 4px;
        `,
    },
    quotesCountText: {
        ...myAccountFilterSectionStyles.resultCountTextStyles,
    },
};
const styles = rfqMyQuotesResultsCountStyles;

const RfqMyQuotesResultsCount = (props: Props) => {
    const { quotesDataView } = useAppSelector(state => {
        return {
            quotesDataView: getQuotesDataView(state, state.pages.rfqMyQuotes.getQuotesParameter),
        };
    });
    const quotesCount =
        quotesDataView.value && quotesDataView.pagination ? quotesDataView.pagination.totalItemCount : 0;

    if (quotesCount === 0) {
        return null;
    }
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.quotesCountText}>
                {`${quotesCount} ${translate(pluralize(quotesCount, "Quote"))}`}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: RfqMyQuotesResultsCount,
    definition: {
        group: "RFQ My Quotes",
        displayName: "RFQ My Quotes Results Count",
        allowedContexts: ["RfqMyQuotesPage"],
    },
};

export default widgetModule;
